import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { UserFlowService } from '../services/UserFlowService';

// Higher Order Component to guard routes based on user flow state
const UserFlowGuard = ({ children }) => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;
    
    // Skip guard check if onboarding was just completed
    // This prevents interference with post-onboarding redirects
    const onboardingCompleted = sessionStorage.getItem('onboarding_completed');
    const userFlowState = UserFlowService.getUserFlowState();
    
    if (onboardingCompleted === 'true' && userFlowState === 'completed') {
      // Allow navigation after onboarding completion
      return;
    }
    
    // Check if current path is allowed for user's state
    if (!UserFlowService.isPathAllowed(currentPath)) {
      const requiredRedirect = UserFlowService.getRequiredRedirect();
      
      if (requiredRedirect) {
        history.replace(requiredRedirect);
      }
    }
  }, [location.pathname, history]);

  return children;
};

export default UserFlowGuard;
